import { render, staticRenderFns } from "./custom-trigger.vue?vue&type=template&id=da504238&scoped=true&"
import script from "./custom-trigger.vue?vue&type=script&lang=js&"
export * from "./custom-trigger.vue?vue&type=script&lang=js&"
import style0 from "./custom-trigger.vue?vue&type=style&index=0&id=da504238&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da504238",
  null
  
)

component.options.__file = "custom-trigger.vue"
export default component.exports